var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"role-navigation"},_vm._l((_vm.items),function(item){return _c('RoleNavigationItem',{key:item.id,attrs:{"item":item,"active-item-id":_vm.activeItemId,"open-group-ids":_vm.openGroupIds},on:{"toggle-group":_vm.toggleGroup}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }